import { Api } from '../../services/http/Api';
import { Flow, FlowPayload } from '../../types/flow/Flow';
import { throwIfGenericApiError } from '../GenericErrors';

class FlowsDatasource {
  protected path = 'basket/flow';

  async createFlow(payload: FlowPayload): Promise<void> {
    const response = await new Api().post(this.path, payload);
    throwIfGenericApiError(response);
  }

  async updateFlow(flowId: number, payload: FlowPayload): Promise<void> {
    const response = await new Api().put(`${this.path}/${flowId}`, payload);
    throwIfGenericApiError(response);
  }

  async getAll(): Promise<Flow[]> {
    const response = await new Api().fetch(this.path);
    throwIfGenericApiError(response);
    if (!Array.isArray(response)) {
      throw new Error('A resposta da consulta de fluxos está inválida.');
    }
    return response as Flow[];
  }

  async deleteFlow(flowId: number): Promise<void> {
    const response = await new Api().delete(`${this.path}/${flowId}`);
    throwIfGenericApiError(response);
  }
}

export const FlowsDataSource = new FlowsDatasource();
